import { render, staticRenderFns } from "./video-modal.vue?vue&type=template&id=600fb2cb&scoped=true&"
import script from "./video-modal.vue?vue&type=script&lang=ts&"
export * from "./video-modal.vue?vue&type=script&lang=ts&"
import style0 from "./video-modal.vue?vue&type=style&index=0&id=600fb2cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600fb2cb",
  null
  
)

export default component.exports